export enum EpisodeStatus {
  PENDING = "pending",
  READY = "ready",
  FAILED = "failed",
}
